/* Asnowera PDP fixes — 14 Oct 2026 (from Clarity recordings) */
(function () {
  if (!document.querySelector('[data-pdp]')) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- 1. Photo viewer: single tap zooms (shoppers were tapping again and again) ---------- */
  var lastToggle = 0;
  // turn off the old double-tap detector so one tap = zoom, next tap = unzoom
  document.addEventListener('touchend', function (e) {
    if (e.target.closest && e.target.closest('.as-lb-slide') && e.changedTouches.length === 1) e.stopImmediatePropagation();
  }, true);
  document.addEventListener('dblclick', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('.as-lb-slide')) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.as-lb-slide img');
    if (!img) return;
    var now = Date.now(); if (now - lastToggle < 400) return; lastToggle = now;
    img.dispatchEvent(new MouseEvent('dblclick', { bubbles: true, cancelable: true, clientX: e.clientX, clientY: e.clientY }));
  }, true);

  /* ---------- 2. Photo viewer: size + Add to cart / Buy now without leaving the photos ---------- */
  function sizeBlock() { return $('#as-size-block'); }
  function selectedSize() { var b = sizeBlock() && $('.as-sz.as-on', sizeBlock()); return b ? b.getAttribute('data-val') : ''; }
  function sync(lb) {
    var bar = $('.as-lb-buy', lb); if (!bar) return;
    var cur = selectedSize();
    $$('[data-v]', bar).forEach(function (b) { var on = b.getAttribute('data-v') === cur; b.classList.toggle('as-on', on); b.setAttribute('aria-pressed', String(on)); });
    var atc = $('.as-lb-atc', bar); if (atc) atc.textContent = cur ? 'Add to cart · ' + cur : 'Add to cart';
  }
  function act(sel) {
    var c = $('.as-lb.as-on .as-lb-close'); if (c) c.click();
    setTimeout(function () { var b = $(sel); if (b) b.click(); }, 380);
  }
  function buildBar(lb) {
    if ($('.as-lb-buy', lb)) return;
    var sb = sizeBlock(), html = '';
    if (sb) {
      html += '<div class="as-lb-sizes" role="group" aria-label="Size">' + $$('.as-sz', sb).map(function (b) {
        var v = (b.getAttribute('data-val') || '').replace(/"/g, '&quot;');
        return '<button type="button" data-v="' + v + '"' + (b.disabled ? ' disabled' : '') + '>' + b.textContent.trim() + '</button>';
      }).join('') + '</div>';
    }
    html += '<div class="as-lb-acts"><button type="button" class="as-lb-atc">Add to cart</button><button type="button" class="as-lb-bn"><span>Buy now</span><img src="https://fastrr-boost-ui.pickrr.com/assets/images/boost_button/upi_options.svg" alt="UPI, Google Pay, PhonePe" width="46" height="18"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg></button></div>';
    var bar = document.createElement('div');
    bar.className = 'as-lb-buy';
    bar.innerHTML = html;
    lb.appendChild(bar);
    lb.classList.add('as-has-buy');
    var hint = $('.as-lb-hint', lb); if (hint) hint.textContent = 'Tap the photo to zoom';
    bar.addEventListener('click', function (e) {
      e.stopPropagation();
      var s = e.target.closest('[data-v]');
      if (s) {
        var o = $$('.as-sz', sizeBlock()).filter(function (b) { return b.getAttribute('data-val') === s.getAttribute('data-v'); })[0];
        if (o) o.click();
        sync(lb); return;
      }
      if (e.target.closest('.as-lb-atc')) act('[data-sticky-btn]');
      else if (e.target.closest('.as-lb-bn')) act('[data-sticky-buy]');
    });
    new MutationObserver(function () { if (lb.classList.contains('as-on')) sync(lb); }).observe(lb, { attributes: true, attributeFilter: ['class'] });
    sync(lb);
  }
  function findLb() { var lb = $('.as-lb'); if (lb) buildBar(lb); return !!lb; }
  if (!findLb()) {
    var mo = new MutationObserver(function () { if (findLb()) mo.disconnect(); });
    mo.observe(document.body, { childList: true });
  }

  /* floating video only after the shopper scrolls past the photos */
  var onS=function(){ document.body.classList.toggle('as-scrolled', window.scrollY > 520); };
  window.addEventListener('scroll', onS, { passive: true }); onS();

  /* ---------- 3. Buy now: never a dead first tap while Shiprocket is still loading ---------- */
  function srReady() { return window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyProduct === 'function'; }
  function markBusy() {
    var els = $$('.sr-headless-checkout, [data-sticky-buy]');
    els.forEach(function (el) { el.classList.add('as-sr-busy'); });
    setTimeout(function () { els.forEach(function (el) { el.classList.remove('as-sr-busy'); }); }, 4000);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.sr-headless-checkout');
    if (!b) return;
    if (srReady()) { if (b.closest('#as-product-form') || b.closest('#as-cart')) markBusy(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (b.__asWait) return;
    b.__asWait = 1; b.classList.add('as-sr-wait');
    var t0 = Date.now();
    (function poll() {
      if (srReady()) { b.__asWait = 0; b.classList.remove('as-sr-wait'); b.click(); return; }
      if (Date.now() - t0 > 8000) {
        b.__asWait = 0; b.classList.remove('as-sr-wait');
        var fb = $('[data-buynow]'); if (fb && b.closest('#as-product-form')) fb.click(); else location.href = '/checkout';
        return;
      }
      setTimeout(poll, 150);
    })();
  }, true);
})();
